// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"87212a06","58":"ff4201d4","96":"c3bc41d9","104":"10c5413e","181":"1009ad97","217":"f33eb4aa","267":"c1fd497c","329":"4cb53e0c","479":"efb82ed1","490":"076e6706","522":"b4678470","570":"fafa6359","629":"05f72669","693":"44cf193d","764":"03ba8922","910":"27eb719d"}[chunkId] + ".chunk.js";
};